import {styled} from '@material-ui/core'

import primaryMobileBackgroundUrl from '../../../../../../assets/images/unlockYourTradingPotentialBanner/education_mobile.webp'
import bannerDesktopBackgroundUrl from '../../../../../../assets/images/unlockYourTradingPotentialBanner/education_desktop.webp'

export const SlideContainer = styled('div')(({theme}) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  padding: '38px 62px',

  backgroundOrigin: 'border-box',
  backgroundRepeat: 'no-repeat',
  backgroundSize: ' cover',

  [theme.breakpoints.down('md')]: {
    padding: '20px 30px',
  },

  [theme.breakpoints.down('xs')]: {
    padding: '40% 30px 20px',
    backgroundImage: ` url(${primaryMobileBackgroundUrl})`,
  },

  backgroundImage: ` url(${bannerDesktopBackgroundUrl})`,
}))

export const BannerBodyLink = styled('a')({
  width: 'auto',
  display: 'flex',
  gap: '12px',
  flexGrow: 1,
  color: '#fff',
  flexDirection: 'column',
  justifyContent: 'center',
})

export const BodyHead = styled('div')(({theme}) => ({
  fontSize: '25px',
  fontWeight: 600,
  lineHeight: '33px',

  [theme.breakpoints.down('md')]: {
    fontSize: '20px',
    lineHeight: '24px',
  },
  [theme.breakpoints.down('xs')]: {
    textAlign: 'center',
  },

  '& > strong': {
    color: 'rgb(255, 0, 0)',
  },
}))

export const BodyContent = styled('div')(({theme}) => ({
  fontSize: '18px',
  fontWeight: 400,
  lineHeight: '24px',

  [theme.breakpoints.down('md')]: {
    fontSize: '16px',
    lineHeight: '20px',
  },
  [theme.breakpoints.down('xs')]: {
    textAlign: 'center',
  },
}))
